import { Cell } from '../../core/Cell';
import { usePageFragment } from '../../hooks';

import type { ElemasonTabData } from '@tectonic/types';
import type { FC } from 'react';

interface TabContentProps {
  data?: ElemasonTabData;
}

const TabContent: FC<TabContentProps> = ({ data }) => {
  const fragment = usePageFragment(data?.fragment);

  return fragment?.cells.map((cell) => <Cell key={cell.id} cell={cell} />);
};

export { TabContent };
